import React from "react";
import * as RAccordion from "@radix-ui/react-accordion";
import { Icon } from "@iconify/react";
import { cn } from "../../utils/cn";

export function Accordion({ items = [] }) {
    return (
        <RAccordion.Root
            className="w-full rounded-md divide-y divide-base-200 dark:divide-base-800"
            type="single"
            collapsible
        >
            {items?.length > 0 &&
                items.map((item, index) => (
                    <RAccordion.Item
                        className={cn(
                            "mt-px overflow-hidden first:mt-0 first:rounded-t last:rounded-b focus-within:relative focus-within:z-10",
                        )}
                        key={index}
                        value={index + 1}
                    >
                        <RAccordion.Header className="flex">
                            <RAccordion.Trigger
                                className={cn(
                                    "group flex flex-1 cursor-pointer items-center justify-between leading-none outline-none",
                                    "text-2xl font-normal font-display h-20",
                                    "text-title transition-colors duration-200 text-left",
                                    "hover:text-cyan-500 dark:hover:text-cyan-400",
                                    "data-[state=open]:text-cyan-500 dark:data-[state=open]:text-cyan-400",
                                )}
                            >
                                {item.title}
                                <Icon
                                    icon="tabler:minus"
                                    className={cn(
                                        "transition-all duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)]",
                                        "size-6 flex-shrink-0 text-[#7E8183]",
                                        "group-data-[state=closed]:hidden",
                                    )}
                                    aria-hidden
                                />
                                <Icon
                                    icon="tabler:plus"
                                    className={cn(
                                        "transition-all duration-300 ease-[cubic-bezier(0.87,_0,_0.13,_1)]",
                                        "size-6 flex-shrink-0 text-[#7E8183]",
                                        "group-data-[state=open]:hidden",
                                    )}
                                    aria-hidden
                                />
                            </RAccordion.Trigger>
                        </RAccordion.Header>
                        <RAccordion.Content
                            className={cn(
                                "data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden",
                            )}
                        >
                            <div className="py-5">{item.body}</div>
                        </RAccordion.Content>
                    </RAccordion.Item>
                ))}
        </RAccordion.Root>
    );
}
